import React from "react";
import { Button } from "react-bootstrap";
import { PlacesType } from "react-tooltip";

type AllProps = {
  children: React.ReactNode;
  onClick: () => void;
  ariaLabel: string;
  tooltipContent?: string;
  tooltipPlace?: PlacesType;
  disabled?: boolean;
  hidden?: boolean;
}

// Description: Button component that is used in children of ToolbarWrapper component
function ToolbarButtonComponent(props: AllProps) {
  const { children, onClick, ariaLabel, tooltipContent, tooltipPlace, disabled, hidden } = props;

  return <span
    className={disabled ? "toolbar-btn--disabled" : ""}
    data-tooltip-id="tb-tooltip"
    data-tooltip-content={tooltipContent}
    data-tooltip-place={tooltipPlace}
    hidden={hidden}
  >
    <Button variant="icon" size="sm" 
      disabled={disabled}
      hidden={hidden}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {children}
    </Button>
  </span>;
}

export default React.memo(ToolbarButtonComponent);
